module.exports = __webpack_public_path__ + "img/bannerKorner-KB-web-entradas-512x723-ES.e0163fa9.jpg";